module.exports = __webpack_public_path__ + "static/media/flight-info-example.3dfa7f67.png";